"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversionApiCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class ConversionApiCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackEventByConversionApi(this.input);
    }
}
exports.ConversionApiCommand = ConversionApiCommand;
